(function () {
  'use strict';
  /* Testimonial carousel: auto-scroll, focused card in full color */
  function initTcar(root = document) {
    root.querySelectorAll('[data-tcar]').forEach((wrap) => {
      if (wrap._init) return;
      wrap._init = true;
      const track = wrap.querySelector('[data-tcar-track]');
      const cards = Array.from(wrap.querySelectorAll('[data-tcar-card]'));
      if (!track || !cards.length) return;
      let i = 0, timer;
      const focus = (n, smooth = true) => {
        i = (n + cards.length) % cards.length;
        cards.forEach((c, k) => c.classList.toggle('is-active', k === i));
        const c = cards[i];
        track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.clientWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
      };
      const start = () => { clearInterval(timer); timer = setInterval(() => focus(i + 1), (parseInt(wrap.dataset.speed, 10) || 4) * 1000); };
      wrap.querySelector('[data-tcar-prev]')?.addEventListener('click', () => { focus(i - 1); start(); });
      wrap.querySelector('[data-tcar-next]')?.addEventListener('click', () => { focus(i + 1); start(); });
      cards.forEach((c, k) => c.addEventListener('click', () => { focus(k); start(); }));
      wrap.addEventListener('mouseenter', () => clearInterval(timer));
      wrap.addEventListener('mouseleave', start);
      focus(0, false);
      if (!(window.Shopify && window.Shopify.designMode)) start();
    });
  }

  /* Recently viewed */
  const KEY = 'recently-viewed';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
  const money = (c) => (window.theme && window.theme.moneyFormat || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, (Number(c) / 100).toFixed(2));
  async function initRecent(root = document) {
    const sec = root.querySelector('[data-recently-viewed]');
    const current = sec ? sec.dataset.current : (document.querySelector('[data-product-section][data-product-url]') || {}).dataset?.productUrl?.split('/').pop();
    let list = read();
    if (current) { list = [current].concat(list.filter((h) => h !== current)).slice(0, 12); write(list); }
    if (!sec || sec._init) return;
    sec._init = true;
    const limit = parseInt(sec.dataset.limit, 10) || 4;
    const handles = list.filter((h) => h !== current).slice(0, limit);
    if (!handles.length) return;
    const grid = sec.querySelector('[data-recently-grid]');
    const root_url = (window.theme && window.theme.routes.root_url || '/').replace(/\/$/, '');
    const items = await Promise.all(handles.map((h) => fetch(root_url + '/products/' + h + '.js').then((r) => r.ok ? r.json() : null).catch(() => null)));
    items.filter(Boolean).forEach((p) => {
      const onSale = p.compare_at_price > p.price;
      const el = document.createElement('div');
      el.className = 'product-grid__item';
      el.innerHTML = '<div class="card"><div class="card__media-wrap"><a class="card__media" href="' + p.url + '">' +
        (p.featured_image ? '<img class="card__img" loading="lazy" src="' + p.featured_image + '&width=600" alt="">' : '') +
        '</a></div><div class="card__info"><a class="card__title" href="' + p.url + '"></a><div class="price">' +
        (onSale ? '<s class="price__compare">' + money(p.compare_at_price) + '</s><span class="price__sale">' + money(p.price) + '</span>' : '<span class="price__regular">' + money(p.price) + '</span>') +
        '</div></div></div>';
      el.querySelector('.card__title').textContent = p.title;
      grid.appendChild(el);
    });
    if (grid.children.length) sec.hidden = false;
  }

  function init(root) { initTcar(root); initRecent(root); }
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
